/* eslint-disable no-loop-func */
import initState from "./initState";

import * as types from "store/types";
import { updateObject, deepClone } from "utils";
import moment from "moment";
import "moment-timezone";

function fetchAccountDetailsSuccess(state, action) {
  return updateObject(state, action.details);
}

function showNotification(state, action) {
  return updateObject(state, {
    notification: updateObject(state.notification, {
      show: true,
      msg: action.details.msg,
      error: action.details.error
    })
  });
}

function hideNotification(state) {
  return updateObject(state, {
    notification: updateObject(state.notification, {
      show: false,
      msg: "",
      error: false
    })
  });
}

function reEnterPasswordStart(state) {
  return updateObject(state, {
    reEnterPassword: updateObject(state.reEnterPassword, {
      loading: true
    })
  });
}

function emailUpdated(state, action) {
  return updateObject(state, {
    reEnterPassword: updateObject(state.reEnterPassword, {
      updated: action.permission
    })
  });
}

function reEnterPasswordFailure(state, action) {
  return updateObject(state, {
    reEnterPassword: updateObject(state.reEnterPassword, {
      loading: false,
      error: { show: true, msg: action.msg }
    })
  });
}

function reEnterPasswordResetState(state) {
  return updateObject(state, {
    reEnterPassword: updateObject(
      state.reEnterPassword,
      deepClone(initState.reEnterPassword)
    )
  });
}

function cancelAccountStart(state, action) {
  return updateObject(state, {
    cancelAccount: updateObject(state.cancelAccount, {
      loading: true,
      details: action.details
    })
  });
}

function cancelAccountFailure(state, action) {
  return updateObject(state, {
    cancelAccount: updateObject(state.cancelAccount, {
      loading: false,
      error: { show: true, msg: action.msg },
      updated: true
    })
  });
}

function cancelAccountResetState(state) {
  return updateObject(state, {
    cancelAccount: updateObject(state.cancelAccount, {
      ...deepClone(initState.cancelAccount),
      details: state.cancelAccount.details,
      loading: false
    })
  });
}

function updatePasswordStart(state) {
  return updateObject(state, {
    changePassword: updateObject(state.changePassword, {
      loading: true
    })
  });
}

function updatePasswordSuccess(state) {
  return updateObject(state, {
    changePassword: updateObject(state.changePassword, {
      updated: true
    })
  });
}

function updatePasswordFailure(state, action) {
  return updateObject(state, {
    changePassword: updateObject(state.changePassword, {
      loading: false,
      error: { show: true, msg: action.msg }
    })
  });
}

function updatePasswordResetState(state) {
  return updateObject(state, {
    changePassword: updateObject(state, deepClone(initState.changePassword))
  });
}

function updateProfileDetails(state, action) {
  const userDetails = {
    firstname: action.details.firstname,
    lastname: action.details.lastname,
    emailid: action.details.emailid,
    phone: action.details.phone,
    countryCode: action.details.countryCode
  };
  const details = {
    userDetails: userDetails
  };

  if (action.details.plan) details.plan = action.details.plan;
  if (action.details.expiryDays !== undefined)
    details.expiryDays = action.details.expiryDays;

  if (action.details.ecommerceFlag !== undefined)
    details.ecommerceFlag = action.details.ecommerceFlag;
  if (action.details.ccfailureAccount !== undefined)
    details.ccfailureAccount = action.details.ccfailureAccount;
  if (action.details.origin !== undefined)
    details.origin = action.details.origin;
  if (action.details.creationDate !== undefined)
    details.creationDate = action.details.creationDate;

  return updateObject(state, { ...details });
}

function fetchCCDetailsSuccess(state, action) {
  let applyPendingChargesFlag = false;
  if (
    state.plan &&
    state.plan.planType === "Paid" &&
    state.ecommerceFlag === "Y"
  ) {
    applyPendingChargesFlag =
      moment(action.data.endDate.split(" ")[0]).format("YYYY-MM-DD") <
      moment(new Date().toLocaleDateString("en-CA")).format("YYYY-MM-DD");
  }
  return updateObject(state, {
    ccDetails: action.data,
    applyPendingChargesFlag: applyPendingChargesFlag
  });
}

function fetchBillingInfoStart(state, action) {
  return updateObject(state, {
    commonLoader: updateObject(state.commonLoader, {
      bill: true
    })
  });
}

function fetchBillingInfoSuccess(state, action) {
  return updateObject(state, {
    billingInfo: action.details,
    commonLoader: updateObject(state.commonLoader, {
      bill: false
    })
  });
}

function changeToPaidPlan(state, action) {
  return updateObject(state, {
    plan: updateObject(state.plan, action.plan)
  });
}

function fetchRenewalPriceSuccess(state, action) {
  return updateObject(state, {
    renewalPrice: action.data.amount
  });
}

function upgradePlanStart(state, action) {
  return updateObject(state, {
    commonLoader: updateObject(state.commonLoader, {
      upgrade: true
    })
  });
}

function upgradePlanSuccess(state, action) {
  return updateObject(state, {
    commonLoader: updateObject(state.commonLoader, {
      upgrade: false
    })
  });
}

function fetchUpgradeProChargeStart(state, action) {
  return updateObject(state, {
    commonLoader: updateObject(state.commonLoader, {
      getProRate: true
    })
  });
}

function fetchUpgradeProChargeSuccess(state, action) {
  return updateObject(state, {
    commonLoader: updateObject(state.commonLoader, {
      getProRate: false
    })
  });
}

function updateCreditCardStart(state, action) {
  return updateObject(state, {
    commonLoader: updateObject(state.commonLoader, {
      update: true
    })
  });
}

function updateCreditCardSuccess(state, action) {
  return updateObject(state, {
    commonLoader: updateObject(state.commonLoader, {
      update: false
    })
  });
}

function fetchUserPlansStart(state, action) {
  return updateObject(state, {
    userPlans: {
      loading: true,
      data: { plans: [] }
    }
  });
}

function fetchUserPlansSuccess(state, action) {
  return updateObject(state, {
    userPlans: updateObject(state.userPlans, {
      loading: false,
      data: action.data
    })
  });
}

function applyPendingChargesStart(state, action) {
  return updateObject(state, {
    commonLoader: updateObject(state.commonLoader, {
      update: true
    })
  });
}

function applyPendingChargesFailed(state, action) {
  return updateObject(state, {
    applyPendingChargesFailed: true,
    commonLoader: updateObject(state.commonLoader, {
      update: false
    })
  });
}

function reducer(state = deepClone(initState), action) {
  switch (action.type) {
    case types.FETCH_ACCOUNT_DETAILS_SUCCESS:
      return fetchAccountDetailsSuccess(state, action);
    case types.SHOW_ACCOUNT_NOTIFICATION:
      return showNotification(state, action);
    case types.HIDE_ACCOUNT_NOTIFICATION:
      return hideNotification(state);
    case types.RE_ENTER_PASSWORD_START:
      return reEnterPasswordStart(state);
    case types.EMAIL_UPDATED:
      return emailUpdated(state, action);
    case types.RE_ENTER_PASSWORD_FAILURE:
      return reEnterPasswordFailure(state, action);
    case types.RE_ENTER_PASSWORD_RESET_STATE:
      return reEnterPasswordResetState(state);
    case types.CANCEL_ACCOUNT_START:
      return cancelAccountStart(state, action);
    case types.CANCEL_ACCOUNT_FAILURE:
      return cancelAccountFailure(state, action);
    case types.CANCEL_ACCOUNT_RESET_STATE:
      return cancelAccountResetState(state);
    case types.UPDATE_PASSWORD_START:
      return updatePasswordStart(state);
    case types.UPDATE_PASSWORD_SUCCESS:
      return updatePasswordSuccess(state);
    case types.UPDATE_PASSWORD_FAILURE:
      return updatePasswordFailure(state, action);
    case types.UPDATE_PASSWORD_RESET_STATE:
      return updatePasswordResetState(state);
    case types.UPDATE_PROFILE_DETAILS:
      return updateProfileDetails(state, action);
    case types.FETCH_CC_DETAILS_SUCCESS:
      return fetchCCDetailsSuccess(state, action);
    case types.FETCH_BILLING_INFO_START:
      return fetchBillingInfoStart(state, action);
    case types.FETCH_BILLING_INFO_SUCCESS:
      return fetchBillingInfoSuccess(state, action);
    case types.CHANGE_TO_PAID_PLAN:
      return changeToPaidPlan(state, action);
    case types.FETCH_RENEWAL_PRICE_SUCCESS:
      return fetchRenewalPriceSuccess(state, action);
    case types.UPGRADE_PLAN_START:
      return upgradePlanStart(state, action);
    case types.UPGRADE_PLAN_SUCCESS:
      return upgradePlanSuccess(state, action);
    case types.FETCH_UPGRADE_PROP_CHARGES_START:
      return fetchUpgradeProChargeStart(state, action);
    case types.FETCH_UPGRADE_PROP_CHARGES_SUCCESS:
      return fetchUpgradeProChargeSuccess(state, action);
    case types.UPDATE_CREDIT_CARD_START:
      return updateCreditCardStart(state, action);
    case types.UPDATE_CREDIT_CARD_SUCCESS:
      return updateCreditCardSuccess(state, action);
    case types.FETCH_USER_PLANS_START:
      return fetchUserPlansStart(state, action);
    case types.FETCH_USER_PLANS_SUCCESS:
      return fetchUserPlansSuccess(state, action);
    case types.APPLY_PENDING_CHARGES_START:
      return applyPendingChargesStart(state, action);
    case types.APPLY_PENDING_CHARGES_FAILED:
      return applyPendingChargesFailed(state, action);
    default:
      return state;
  }
}

export default reducer;
